import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'

import ExpandableImage from '../ExpandableImage'

import { isEven } from '../../utils/num'

const BenefitsToYou = ({ upper, lower }) => (
  <section
    id="benefits-to-you"
    className="c-section c-section--forBenefits c-section--forBenefits--you"
  >
    <div className="c-section__outer container">
      <div className="c-section__tag">Benefits to you</div>
      <div className="c-section__inner">
        <div className="c-forBenefits">
          {upper.map((blurb) => (
            <div key={blurb.title} className="c-forBenefitsInfo row">
              <div className="c-forBenefitsInfo__block c-forBenefitsInfo__block--icon col-12 col-md-3">
                <img
                  className="c-forBenefitsInfo__icon img-fluid"
                  src={`/images/icons/${blurb.icon}.svg`}
                />
              </div>

              <div className="c-forBenefitsInfo__block c-forBenefitsInfo__block--text col-12 col-md-7 d-flex flex-column justify-content-center">
                <h2 className="c-forBenefitsInfo__header">{blurb.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: blurb.text }} />
              </div>
            </div>
          ))}

          <br />

          {lower.map((blurb, i) => (
            <div
              key={blurb.title}
              className={`c-forBenefitsCard ${
                !isEven(i) ? 'c-forBenefitsCard--reversed' : ''
              }`}
            >
              <div className="c-forBenefitsCard__block c-forBenefitsCard__block--text">
                <h5 className="c-forBenefitsCard__header">{blurb.title}</h5>
                <div className="c-forBenefitsCard__text">
                  <p dangerouslySetInnerHTML={{ __html: blurb.text }} />
                </div>
              </div>

              <div className="c-forBenefitsCard__block c-forBenefitsCard__block--image">
                <ExpandableImage
                  imageData={blurb.image.modal}
                  bottomRight={isEven(i)}
                >
                  <picture>
                    <source
                      type="image/webp"
                      srcSet={blurb.image.childImageSharp.fixed.srcSetWebp}
                    />
                    <img
                      srcSet={blurb.image.childImageSharp.fixed.srcSet}
                      src={blurb.image.childImageSharp.fixed.src}
                      alt={blurb.title}
                      title={blurb.title}
                      width={blurb.image.childImageSharp.fixed.width}
                      height={blurb.image.childImageSharp.fixed.height}
                      loading="lazy"
                      className="c-forBenefitsInfo__icon img-fluid"
                      // style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; object-fit: cover; object-position: center center; opacity: 1; transition: opacity 500ms ease 0s;"
                    />
                  </picture>
                </ExpandableImage>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
)

BenefitsToYou.defaultProps = {
  upper: [],
  lower: [],
}

BenefitsToYou.propTypes = {
  upper: PropTypes.array,
  lower: PropTypes.array,
}

export default BenefitsToYou

export const FragmentQuery = graphql`
  fragment BenefitsToYouFragment on MarkdownRemarkFrontmatter {
    benefitsYou {
      blurbsOne {
        title
        text
        icon
      }
      blurbsTwo {
        title
        text
        image {
          modal: childImageSharp {
            ...SharpImageModalFragment
          }
          childImageSharp {
            fixed(width: 550, quality: 90) {
              ...GatsbyImageSharpFixed_withWebp
            }
          }
        }
      }
    }
  }
`
